// eslint-disable-next-line no-unused-vars
const isDevelopment = process.env.REACT_APP_ENVIRONMENT === 'Development'
const isInt = process.env.REACT_APP_ENVIRONMENT === 'IntegrationTest'
const isAct = process.env.REACT_APP_ENVIRONMENT === 'AcceptanceTest'
const isProduction = process.env.REACT_APP_ENVIRONMENT === 'Production'

const dev = { 
    //awsBaseUrl: "https://hzkgeagtj6.execute-api.eu-west-2.amazonaws.com/sandbox/",
    awsBaseUrl: "https://kacnkxeqwi.execute-api.eu-west-2.amazonaws.com/dev/",
    fileUpload: {
        presignedUrl: 'attachments',
        maxNoFiles: 5,
        maxFileSizeInMB: 5, 
    },
    postSubmitPath: 'referralsubmission',
    apiGatewayKey: 'c75ce2c7-37c9-4582-abdb-2580aa8a9ed6',

    azureBaseUrl: "https://api-dev.leeds.gov.uk/public/",
    azureAddress: {
        apiUrl: "catsaddresses/lookup/postcode/",
        subscriptionKey: "c32ceee5b13846d79aa12358f7142696",
    }, 
    azureUtrnGenerator: {
        apiUrl: "catsutrngenerator/generateutrn", 
        subscriptionKey: "c32ceee5b13846d79aa12358f7142696",
        apiVersion: "v1.0.0",
    },
    cisApis: {
        organisationPath: "cis/organisations",
        departmentsPath: 'cis/departments',
        ethinicOriginPath: 'cis/ethnicities',
        languageSpokenPath: 'cis/languages',
        healthConditionsPath: 'cis/healthconditions',
        mainSupportTypesPath: 'asc/supporttypes',
        subscriptionKey: "c32ceee5b13846d79aa12358f7142696",
    },
    timeout: {
        totalTimeInMins: 10,
        promptBeforeIdleInMins: 2
    }
};

const int = {
    awsBaseUrl: process.env.REACT_APP_API_GATEWAY_URL,
    fileUpload: {
        presignedUrl: 'attachments',
        maxNoFiles: 5,
        maxFileSizeInMB: 5, 
    },
    postSubmitPath: 'referralsubmission',
    apiGatewayKey: 'c75ce2c7-37c9-4582-abdb-2580aa8a9ed6',

    azureBaseUrl: "https://api-int.leeds.gov.uk/public/",
    azureAddress: {
        apiUrl: "catsaddresses/lookup/postcode/",
        subscriptionKey: "4f3c255b1df04c3b87c06f46ad539c35",
    }, 
    azureUtrnGenerator: {
        apiUrl: "catsutrngenerator/generateutrn", 
        subscriptionKey: "4f3c255b1df04c3b87c06f46ad539c35",
        apiVersion: "v1.0.0",
    },
    cisApis: {
        organisationPath: "cis/organisations",
        departmentsPath: 'cis/departments',
        ethinicOriginPath: 'cis/ethnicities',
        languageSpokenPath: 'cis/languages',
        healthConditionsPath: 'cis/healthconditions',
        mainSupportTypesPath: 'asc/supporttypes',
        subscriptionKey: "4f3c255b1df04c3b87c06f46ad539c35",
    },
    timeout: {
        totalTimeInMins: 10,
        promptBeforeIdleInMins: 2
    }
};

const act = {
    awsBaseUrl: process.env.REACT_APP_API_GATEWAY_URL,
    fileUpload: {
        presignedUrl: 'attachments',
        maxNoFiles: 5,
        maxFileSizeInMB: 5, 
    },
    postSubmitPath: 'referralsubmission',
    apiGatewayKey: 'c75ce2c7-37c9-4582-abdb-2580aa8a9ed6',

    azureBaseUrl: "https://api-act.leeds.gov.uk/public/",
    azureAddress: {
        apiUrl: "catsaddresses/lookup/postcode/",
        subscriptionKey: "31d645e9724440b79d253566fdb297d0",
    }, 
    azureUtrnGenerator: {
        apiUrl: "catsutrngenerator/generateutrn", 
        subscriptionKey: "31d645e9724440b79d253566fdb297d0",
        apiVersion: "v1.0.0",
    },
    cisApis: {
        organisationPath: "cis/organisations",
        departmentsPath: 'cis/departments',
        ethinicOriginPath: 'cis/ethnicities',
        languageSpokenPath: 'cis/languages',
        healthConditionsPath: 'cis/healthconditions',
        mainSupportTypesPath: 'asc/supporttypes',
        subscriptionKey: "31d645e9724440b79d253566fdb297d0",
    },
    timeout: {
        totalTimeInMins: 10,
        promptBeforeIdleInMins: 2
    }
};
    
const prod = {
    awsBaseUrl: process.env.REACT_APP_API_GATEWAY_URL,
    fileUpload: {
        presignedUrl: 'attachments',
        maxNoFiles: 5,
        maxFileSizeInMB: 5, 
    },
    postSubmitPath: 'referralsubmission',
    apiGatewayKey: 'c75ce2c7-37c9-4582-abdb-2580aa8a9ed6',

    azureBaseUrl: "https://api.leeds.gov.uk/public/",
    azureAddress: {
        apiUrl: "catsaddresses/lookup/postcode/",
        subscriptionKey: "5da965de1eab4ed79487eb5ae14082c1",
    }, 
    azureUtrnGenerator: {
        apiUrl: "catsutrngenerator/generateutrn", 
        subscriptionKey: "5da965de1eab4ed79487eb5ae14082c1",
        apiVersion: "v1.0.0",
    },
    cisApis: {
        organisationPath: "cis/organisations",
        departmentsPath: 'cis/departments',
        ethinicOriginPath: 'cis/ethnicities',
        languageSpokenPath: 'cis/languages',
        healthConditionsPath: 'cis/healthconditions',
        mainSupportTypesPath: 'asc/supporttypes',
        subscriptionKey: "5da965de1eab4ed79487eb5ae14082c1",
    },
    timeout: {
        totalTimeInMins: 30,
        promptBeforeIdleInMins: 5
    }
};
export const config = isProduction ? prod :
    isAct ? act : 
    isInt ? int : dev;
